import { lazy } from 'react';

const Drafts = lazy(() => import('./drafts'));
const Published = lazy(() => import('./published'));
const Scheduled = lazy(() => import('./scheduled'));
const Failed = lazy(() => import('./failed'));
const InProgress = lazy(() => import('./in-progress'));
const Review = lazy(() => import('./review'));

export {
  Drafts,
  Published,
  Scheduled,
  Failed,
  InProgress,
  Review
};
